<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!--api- 1  -->
        <v-card v-if="ay_std_div_list != null" class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Relative Details Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="sel_ay_data"
                            return-object
                            :items="ay_std_div_list"
                            item-text="ay"
                            label="Academic Year"
                            outlined
                            @change="getStd()"
                            persistent-hint
                            hint="Select Academic Year "
                        />
                    </v-col>
                    <v-col sm="2" v-if="std_div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" persistent-hint hint="Select Standard " />
                    </v-col>
                    <v-col sm="2" v-if="div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list" item-text="div_name" label="Division" outlined persistent-hint hint="Select Division" />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name" return-object label="Status" outlined @change="check_values" persistent-hint hint="Select Status" />
                    </v-col>
                    <v-col sm="2" v-if="sel_ay_data && sel_std_data && status">
                        <v-btn class="mt-6 button" color="primary" @click="getReport" :loading="fetch_btn_load">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>

            <!-- <ol>
            <li v-for="(rep,index) in report" :key="index">{{ rep }}</li>
        </ol>  -->
        <!-- <download-excel  v-if="report!=''"
                    class="mr-2 pb-3 pt-2"
                    :data="bookList1"
                    :fields="table_fields"
                    worksheet="RelativeDetailsData"
                    name="RelativeDetailsData.xls"
                    >
                    <v-btn  v-if="report!=''" color="success" outlined rounded>
                        <v-icon dark>mdi-file-excel</v-icon> Export
                    </v-btn>
                </download-excel> -->
                <v-btn
            class="ma-2 no-display "
            v-if="report!=''"
              rounded
              color="success"
              outlined
              @click="fnExcelReport('my-table-id', 'RelativeDetailsReport')"
              :loading="loader"
              ><v-icon  color="success">mdi-export</v-icon>Export</v-btn
            >

            <div id="my-table-id">
            <v-data-table v-if="report!=''" :headers="headers" :items="bookList1" dense sort-by="" class="elevation-1 mytable" :search="search" @current-items="getFiltered">
                <template v-slot:top class="pb-5">
                    <v-row justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                    <v-row>
                                        <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete
                                                    class="mr-2 ml-3 pb-5 pt-2"
                                                    flat
                                                    hide-details
                                                    small
                                                    rounded
                                                    dense
                                                    outlined
                                                    color="#0F2027"
                                                    :label="header.text"
                                                    multiple
                                                    clearable
                                                    :items="columnValueList(header.value)"
                                                    v-model="filters[header.value]"
                                                ></v-autocomplete>
                                            </span>
                                        </span>
                                    </v-row>
                                </th>
                            </div>
                        </tr>
                    </v-row>
                </template>
            </v-data-table>
            </div>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        components: {},
        data: () => ({
            //1
            report: [],
            overlay: false,
            search: "",
            ay_std_data: null,
            fetch_btn_load: false,
            current_academic_year: "",
            std: "",
            status: "",
            //fields

            ay_std_div_list: null,
            sel_ay_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            status_list: [],
            snackbar: false,
            snackbar_msg: "",
            color: "",

            filterArr: [],
            filters: {
                stud_reg_no: [],
                rel_department: [],
                rel_education: [],
                rel_relationtype: [],
                rel_occupation: [],
                rel_designation: [],
            },
            headers: [
                { text: "Sr. No.", value: "sr_no" },
                { text: "Registration No.", value: "stud_reg_no" },
                { text: "Student Name", value: "stud_name" },
                { text: "Standard", value: "stud_std" },
                { text: "Division", value: "stud_div" },
                { text: "Relative Type", value: "rel_relationtype" },
                { text: "Relative Name", value: "rel_name" },
                { text: "Relative Occupation", value: "rel_occupation" },
                { text: "Relative Aadhaar No.", value: "rel_aadharno" },
                { text: "Relative Department", value: "rel_department" },
                { text: "Relative Education", value: "rel_education" },
                { text: "Relative Email", value: "rel_email" },
                { text: "Relative Contact No.", value: "rel_contact_no" },
                { text: "Relative Designation", value: "rel_designation" },
                { text: "Relative Income", value: "rel_income" },
                { text: "Relative Organization Name", value: "rel_organization_name" },
                { text: "Relative Office Address", value: "rel_office_address" },
            ],
             table_fields: {
                "Sr. No": "sr_no",
                "Registration No.": "stud_reg_no",
                "Student Name": "stud_name" ,
                "Standard": "stud_std",
                "Division": "stud_div",
                "Relative Type": "rel_relationtype",
                "Relative Name": "rel_name",
                "Relative Occupation": "rel_occupation",
                "Relative Aadhar No.": "rel_aadharno",
                "Relative Department": "rel_department",
                "Relative Education": "rel_education",
                "Relative Email": "rel_email",
                "Relative Contact No.": "rel_contact_no",
                "Relative Designation": "rel_designation",
                "Relative Income": "rel_income",
                "Relative Organization Name": "rel_organization_name",
                "Relative Office Address": "rel_office_address"
             }
        }),
        computed: {
            bookList1() {
                return this.report.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
          
  fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>SR. No.</th>
      <th>Registration No.</th>
      <th>Student Name</th>
      <th>Standard</th>
      <th>Division</th>
      <th>Relative Type</th>
      <th>Relative Name</th>
      <th>Relative Occupation</th>
      <th>Relative Aadhaar No.</th>
      <th>Relative Department</th>
      <th>Relative Education</th>
      <th>Relative Email</th>
      <th>Relative Contact No.</th>
      <th>Relative Designation</th>
      <th>Relative Income</th>
      <th>Relative Organization Name</th>
      <th>Relative Office Address</th>
    </tr>`;

  this.bookList1.forEach((s, index) => {
    tab_text += `
    <tr>
                <td>${index + 1}</td>
                <td>${s.stud_reg_no}</td>
                <td>${s.stud_name}</td>
                <td>${s.stud_std}</td>
                <td>${s.stud_div}</td>
                <td>${s.rel_relationtype}</td>
                <td>${s.rel_name}</td>
                <td>${s.rel_occupation}</td>
                <td>${s.rel_aadharno}</td>
                <td>${s.rel_department}</td>
                <td>${s.rel_education}</td>
                <td>${s.rel_email}</td>
                <td>${s.rel_contact_no}</td>
                <td>${s.rel_designation}</td>
                <td>${s.rel_income}</td>
                <td>${s.rel_organization_name}</td>
                <td>${s.rel_office_address}</td>
            </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.report.map((d) => d[val]);
            },
            async getReport() {
                // alert(ay)

                this.fetch_btn_load = true;

                let div;
                if (this.div != null) {
                    div = this.div.div_off_id;
                    if (this.div.div_off_id) {
                        div = this.div.div_off_id;
                    } else {
                        div = this.div;
                    }
                }
                let ay;
                if (this.sel_ay_data.ay_id) {
                    ay = this.sel_ay_data.ay_id;
                } else if (this.sel_ay_data.id) {
                    ay = this.sel_ay_data.id;
                }
                let data = {
                    current_academic_year_id: ay,
                    standard_obj: this.sel_std_data,
                    division_off_id: div,
                    status: this.status,
                    field: this.field,
                    document_type: this.document_type,
                };
                try {
                    const res = await axios.post("/AdmissionReport/getRalativeDetailsReport", data);
                    this.fetch_btn_load = false;

                    if (res.data.flag == "YES") {
                        this.report = res.data.report;
                        if (this.report.length == 0) this.showSnackbar("error", "No record found");
                        else this.showSnackbar("success", "Record found");
                    } else {
                        this.showSnackbar("error", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (error) {
                    console.log(error);
                    this.showSnackbar("error", "Something went wrong..."); // show snackbar
                    this.fetch_btn_load = false;
                } finally {
                    this.fetch_btn_load = false;
                }
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            check_values() {
                if (this.sel_std_data == null) {
                    this.showSnackbar("#b71c1c", "Please select Academic Year then proceed further!"); // show snackbar
                }
            },
            getStd() {
                this.std_div_list = ["All"];
                this.sel_std_data = "All";
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
                this.std_div_list.unshift("All");
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },

            get_ay_std() {
                this.overlay = true;
                //api-1
                axios
                    .post("/CommonAPI/get_ay_std_div_for_report")
                    .then((res) => {
                        this.overlay = false;
                        // if (res.data.msg == "200") {
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.curr_ay;
                        this.status_list = res.data.status_list;
                    })
                    .catch((error) => {
                        this.overlay = false;
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                        //close loader
                    });
            },
        },
        created() {
            this.awspath = localStorage.getItem("awspath");
        },
        mounted() {
            this.get_ay_std();
            this.basepath = localStorage.getItem("awspath");
        },
    };
</script>
<style scoped>
    .text-color {
        color: red;
    }

    .mytable1 {
        /* width: 90%; */
        overflow-x: scroll !important;
    }
    .regno :hover {
        cursor: pointer;
    }
</style>
